import type { Dict } from "../core.js";
import type { products as vi } from "../vi/products.js";

export const products: Dict<typeof vi> = {
  title: "Products",
  subtitle: "Product → service → resource. The catalog is declared in source and loaded with ",
  loadListFailed: "Couldn't load the product catalog.",
  emptyBefore: "The catalog hasn't been loaded. Run ",
  emptyAfter: ".",
  cardMeta: "{services} services · {resources} resources · {criticality}",
  noOwner: "No owner",

  loadFailed: "Couldn't load the product.",
  noOwnerAssign: "No owner — assign now",
  services: "Services",
  "col.service": "Service",
  "col.type": "Type",
  "col.tier": "Tier",
  "col.liveness": "Up",
  "col.resourcesUsed": "Resources used",
  "col.dependsOn": "Depends on",
  noOwnerTag: "no owner",
  up: "Up",
  down: "Not responding",
  resources: "Resources",
  "col.resource": "Resource",
  "col.observability": "Hub visibility",
  "col.size": "Size",
  userMetricsBefore: "Per-product user metrics ",
  userMetricsStrong: "can't be measured yet",
  userMetricsMiddle: ": ",
  userMetricsAfter:
    " is stored per connector, and rolling it up to products hits the same « summing distinct counts » problem we rejected on the Users screen. Per-source numbers are on ",
  userMetricsLink: "Users",
  userMetricsEnd: ".",
};
